<template>
  <div id="app">
    <bank-header></bank-header>
      <div class="v-view">
          <router-view></router-view>
      </div>
    <bank-footer></bank-footer>
  </div>
</template>

<script>
import BankHeader from './components/BankHeader.vue'
import BankFooter from './components/BankFooter.vue'
import $ from 'jquery'
export default {
  name: 'App',
  components: {
    BankHeader,
    BankFooter,
  },
    created () { // 属性已有，结构未渲染
        window.onmessage = e => {
            const { type } = e.data
            switch (type) {
                case 'open':
                    this.$store.commit('UPDATE_EDIT', true)
                    break
                case 'close':
                    this.$store.commit('UPDATE_EDIT', false)
                    break
                case 'reload':
                    setTimeout(() => {
                        this.$store.dispatch('getDecorateInfo')
                    }, 200)
                    break
                default:
                    break
            }
        }
    },
    computed: {
        openEdit () {
            let open = this.$store.getters.openEdit
            if (open) {
                $('a').removeAttr('target')
            }
            return open
        }
    },
    mounted () {
        $('body').on('mouseover', '.decorate', e => {
            if (this.openEdit) {
                $(e.target).parents('.decorate').find('#edit-mask:hidden:first').show()
            }
        }).on('mouseout', '.decorate', e => {
            if (this.openEdit) {
                $(e.target).parents('.decorate').find('#edit-mask:first').hide()
            }
        }).on('click', '.decorate .mask-edit-btn', e => {
            const editInfo = $(e.target).attr('editinfo')
            if (this.openEdit && editInfo) {
                window.parent.postMessage({ editInfo: editInfo, router: this.$route.fullPath }, '*')
            }
        })
    },
}
</script>

<style lang="scss">
@import '@/style/common/common.scss';
</style>
